<template>
  <div>
    <b-container class="mt-5 mb-5">

      <h1 class="fs-4 font-weight-bold mb-4">Developers</h1>

      <b-card class="mb-3">
        <p class="text-muted">
          Gebruik deze gegevens om Tixgo te koppelen aan externe systemen,
          zoals onze Tixgo WordPress-plugin.
        </p>

        <!-- API BASE URL -->
        <b-form-group label="API Base URL">
          <b-input-group>
            <b-form-input
              :value="developer.base_url"
              readonly
            />
            <b-input-group-append>
              <b-button
                variant="outline-secondary"
                @click="copy(developer.base_url)"
              >
                Kopiëren
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>

        <!-- API KEY -->
        <b-form-group label="API Key">
          <b-input-group>
            <b-form-input
              :type="showKey ? 'text' : 'password'"
              :value="developer.api_key"
              readonly
            />
            <b-input-group-append>
              <b-button
                variant="outline-secondary"
                @click="showKey = !showKey"
              >
                {{ showKey ? 'Verbergen' : 'Tonen' }}
              </b-button>
              <b-button
                variant="outline-secondary"
                @click="copy(developer.api_key)"
              >
                Kopiëren
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>

        <small class="text-muted">
          Behandel deze API key als een wachtwoord. Deel deze niet openbaar.
        </small>
      </b-card>

    </b-container>
  </div>
</template>

<script>
export default {
  metaInfo: {
    title: 'Developers'
  },

  data() {
    return {
      developer: {
        base_url: '',
        api_key: ''
      },
      showKey: false
    }
  },

  created() {
    this.fetchDeveloperCredentials();
  },

  methods: {
    fetchDeveloperCredentials() {
      this.$axios
        .get('https://api.tixgo.nl/developers/credentials')
        .then(response => {
          this.developer = response.data;
        })
        .catch(error => {
          console.error(error);
          this.$bvToast.toast(
            'Kon developergegevens niet laden.',
            {
              variant: 'danger',
              solid: true,
              autoHideDelay: 3000
            }
          );
        });
    },

    copy(value) {
      if (!value) return;

      navigator.clipboard.writeText(value).then(() => {
        this.$bvToast.toast(
          'Gekopieerd naar klembord',
          {
            variant: 'success',
            solid: true,
            autoHideDelay: 2000
          }
        );
      });
    }
  }
}
</script>
